import { Datagrid, DateField, List, TextField, TextInput } from "react-admin";

const filter = [<TextInput source="name" label='Nome' alwaysOn/>]

export const ThemeList = (props) =>
    <List
        exporter={false}
        bulkActionButtons={false}
        filters={filter}
        title={'Ramos do direito'}
        sort={{ field: 'name', order: "ASC" }}
        {...props}
    >
        <Datagrid rowClick={'edit'}>
            <TextField source="name" label={'Nome'} />
            <DateField source="created_at" label={'Criado em'} />
        </Datagrid>
    </List>